import React, {Component} from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import * as routes from '../../constants/routes';
import Navigation from '../Navigation';
import SignInPage from '../SignIn';
import VendorHistory from '../VendorHistory';
import PasswordForgetPage from '../PasswordForget';
import HomePage from '../Home';
import AccountPage from '../Account';
import withAuthentication from '../Session/withAuthentication';
import Admin from '../Admin';
import UploadUser from '../Admin/UploadUser';
import FormUpload from '../Home/formUpload';
import ChatAdmin from '../Admin/ChatAdmin';
import ChatUser from '../Home/ChatUser';
import firebase from 'firebase';
// import Header from '../Main/Header';
// import Main from '../Main';

import './index.css';

class App extends Component{
  constructor(props){
    super(props);
    this.state = {
      admin : '',
      toggle : true
    }
  }

  componentwillMount(){
    var self = this;
    firebase.database().ref('users/admin/details').once('value',function(snap){
      if(snap.hasChild(firebase.auth().currentUser.uid)){
        self.setState({
          admin : true
        })
      }
    })
  }

  render(){
    console.log(this.props);
    return(
      <Router path="/" >
        <div>
          <div className="app">
            <Navigation admin={this.state.admin}/>
            <Route exact path="/" component={() => <SignInPage />} />
            <Route exact 
              path={routes.ADMIN} 
              component={() => <Admin toggle={this.onToggle} 
              history={this.props.history}/>} >
                <Route exact path={routes.HOME} component={() => <HomePage toggle={this.onToggle}/>} />
                <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
                <Route exact path={routes.VENDORHISTORY} component={() => <VendorHistory />} />
                <Route exact path={routes.UPLOADUSER} component={() => <UploadUser />} />
            </Route>
            
            <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
            
            <Route exact path={routes.HOME} component={() => <HomePage toggle={this.onToggle}/>} />
            <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
            <Route exact path={routes.VENDORHISTORY} component={() => <VendorHistory />} />
            <Route exact path={routes.UPLOADUSER} component={() => <UploadUser />} />
            <Route exact path={routes.FORMUPLOAD} component={() => <FormUpload />} />
            <Route exact path={routes.CHATADMIN} component={() => <ChatAdmin />} />
            <Route exact path={routes.CHATUSER} component={() => <ChatUser />} />  
            {/* <Route exact path={routes.HEADER} component={() => <Header />} /> */}
          </div>
        </div>
      </Router>
    )
  }
}
  

export default withAuthentication(App);